"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var scenes_1 = require("./scenes");
var DEPARTMENT_NAMES = [
    'Costume',
    'Hair',
    'Makeup',
    'Location',
    'Set Dec',
    'Props',
];
function sortByNumberField(entities, field, desc) {
    var sort = entities.sort(function (a, b) { return Number(a[field]) - Number(b[field]); });
    return desc ? sort.reverse() : sort;
}
exports.sortByNumberField = sortByNumberField;
function sortByStringField(entities, field, desc) {
    var sorted = entities.sort(function (a, b) {
        // tslint:disable-next-line
        return stringCompare(a[field], b[field]);
    });
    if (desc) {
        return sorted.reverse();
    }
    return sorted;
}
exports.sortByStringField = sortByStringField;
function sortProperty(array, sortFunction, asc, property) {
    // tslint:disable-line
    array.sort(function (a, b) { return sortFunction(a[property], b[property]); });
    return asc ? array : array.reverse();
}
exports.sortProperty = sortProperty;
function copyAndSort(construct, array, sortFunction, asc) {
    // tslint:disable-line
    var new_array = array.map(function (a) { return new construct(a); });
    new_array.sort(sortFunction);
    return asc ? new_array : new_array.reverse();
}
exports.copyAndSort = copyAndSort;
function copyAndSortProperty(construct, array, sortFunction, asc, property) {
    // tslint:disable-line
    var new_array = array.map(function (a) { return new construct(a); });
    new_array.sort(function (a, b) { return sortFunction(a[property], b[property]); });
    return asc ? new_array : new_array.reverse();
}
exports.copyAndSortProperty = copyAndSortProperty;
/**
 * sorts and breaks up a given property on an entity by num or string
 */
function copyAndSortPropertyByNumOrString(construct, array, asc, property) {
    // tslint:disable-line
    var new_array = array.map(function (a) { return new construct(a); });
    new_array.sort(function (a, b) {
        var aa = breakup(a[property]);
        var bb = breakup(b[property]);
        return compareAlphanumArrays(aa, bb);
    });
    return asc ? new_array : new_array.reverse();
}
exports.copyAndSortPropertyByNumOrString = copyAndSortPropertyByNumOrString;
function wrapBoxStorageLocationSort(array, locByDeptMap, asc) {
    // tslint:disable-line
    array.sort(function (a, b) {
        var _a, _b;
        var aLocs = locByDeptMap[a.department]
            ? locByDeptMap[a.department]
            : (_a = {}, _a[a.storage_location_id] = null, _a);
        var bLocs = locByDeptMap[b.department]
            ? locByDeptMap[b.department]
            : (_b = {}, _b[b.storage_location_id] = null, _b);
        var aName = aLocs[a.storage_location_id]
            ? aLocs[a.storage_location_id].name
            : null;
        var bName = bLocs[b.storage_location_id]
            ? bLocs[b.storage_location_id].name
            : null;
        return stringCompare(aName, bName);
    });
    return asc ? array : array.reverse();
}
exports.wrapBoxStorageLocationSort = wrapBoxStorageLocationSort;
/** Comparator Functions */
function numberCompare(a, b) {
    return a - b;
}
exports.numberCompare = numberCompare;
/** Case insensitive */
function stringCompare(a, b) {
    var check = nullCheck(a, b);
    if (check !== null) {
        return check;
    }
    var aa = a.toLowerCase(), bb = b.toLowerCase();
    if (aa < bb) {
        return -1;
    }
    else if (aa > bb) {
        return 1;
    }
    return 0;
}
exports.stringCompare = stringCompare;
function dateCompare(a, b) {
    if (a && !b) {
        return -1;
    }
    else if (!a && b) {
        return 1;
    }
    else if (!a && !b) {
        return 0;
    }
    return a.valueOf() - b.valueOf();
}
exports.dateCompare = dateCompare;
// For sorting departments
function departmentCompare(a, b) {
    // Check if either character is null
    var check = nullCheck(a, b);
    if (check !== null) {
        return check;
    }
    return stringCompare(DEPARTMENT_NAMES[a - 1], DEPARTMENT_NAMES[b - 1]);
}
exports.departmentCompare = departmentCompare;
/** For sorting CmChanges */
function changeCompare(a, b, alpha) {
    // tslint:disable-line
    return scenes_1.compareSceneNames(a.change_num, b.change_num, alpha);
}
exports.changeCompare = changeCompare;
/** For sorting HaChanges and MuChanges */
function compareJustNumFirst(a, b) {
    // tslint:disable-line
    var num_a = a.split(',');
    var num_b = b.split(',');
    num_a = a[0].replace('/[^0-9]/', '');
    num_b = b[0].replace('/[^0-9]/', '');
    if (!isNaN(num_a) && !isNaN(num_b)) {
        if (num_a !== num_b) {
            return num_a < num_b ? -1 : 1;
        }
        else {
            var let_a = a.replace('/[^0-9]/', '').toLowerCase();
            var let_b = b.replace('/[^0-9]/', '').toLowerCase();
            return let_a < let_b ? -1 : 1;
        }
    }
    else {
        if (!isNaN(num_a)) {
            return 1;
        }
        else if (!isNaN(num_b)) {
            return -1;
        }
        return num_a.toLowerCase() < num_b.toLowerCase() ? -1 : 1;
    }
}
exports.compareJustNumFirst = compareJustNumFirst;
function characterCompare(a, b) {
    // tslint:disable-line
    // Check if either character is null
    var check = nullCheck(a, b);
    if (check !== null) {
        return check;
    }
    // Check character type
    if (a.is_primary !== b.is_primary) {
        if (a.is_primary === 1) {
            return -1;
        }
        else {
            return 1;
        }
    }
    var a_num;
    if (typeof a.char_num !== 'undefined' &&
        a.char_num !== null &&
        a.char_num !== '') {
        a_num = '' + a.char_num;
    }
    var b_num;
    if (typeof b.char_num !== 'undefined' &&
        b.char_num !== null &&
        b.char_num !== '') {
        b_num = '' + b.char_num;
    }
    // Check if char nums exist, compare char nums (if primary) then compare names
    if (a_num && !b_num && a.is_primary) {
        return -1;
    }
    else if (b_num && !a_num && a.is_primary) {
        return 1;
    }
    else if (a_num !== b_num && a.is_primary) {
        var aa = breakup(a_num);
        var bb = breakup(b_num);
        return compareAlphanumArrays(aa, bb);
    }
    else {
        return firstNameCompare(a, b);
    }
}
exports.characterCompare = characterCompare;
function firstNameCompare(a, b) {
    // tslint:disable-line
    var check = nullCheck(a, b);
    if (check !== null) {
        return check;
    }
    var aa = breakup((a.first_name ? a.first_name.toLowerCase() : ' ') +
        ' ' +
        (a.last_name ? a.last_name.toLowerCase() : ' '));
    var bb = breakup((b.first_name ? b.first_name.toLowerCase() : ' ') +
        ' ' +
        (b.last_name ? b.last_name.toLowerCase() : ' '));
    return compareAlphanumArrays(aa, bb);
}
exports.firstNameCompare = firstNameCompare;
function lastNameCompare(a, b) {
    // tslint:disable-line
    var check = nullCheck(a, b);
    if (check !== null) {
        return check;
    }
    var aa = breakup((a.last_name ? a.last_name.toLowerCase() : ' ') +
        ' ' +
        (a.first_name ? a.first_name.toLowerCase() : ' '));
    var bb = breakup((b.last_name ? b.last_name.toLowerCase() : ' ') +
        ' ' +
        (b.first_name ? b.first_name.toLowerCase() : ' '));
    return compareAlphanumArrays(aa, bb);
}
exports.lastNameCompare = lastNameCompare;
function prodCompare(aProd, bProd) {
    var aEpNum = aProd && aProd.episode_num ? aProd.episode_num : '';
    var aTitle = aProd && aProd.prod_name ? aProd.prod_name.toLowerCase() : '';
    var bEpNum = bProd && bProd.episode_num ? bProd.episode_num : '';
    var bTitle = bProd && bProd.prod_name ? bProd.prod_name.toLowerCase() : '';
    var partsCompare = scenes_1.compareParts(aEpNum, bEpNum);
    if (partsCompare !== 0) {
        return 1 * partsCompare;
    }
    else {
        return scenes_1.compareAlphanum(aTitle, bTitle);
    }
}
exports.prodCompare = prodCompare;
function setNumberNameCompare(a, b, alpha) {
    // tslint:disable-line
    var aSetNum = a.number || '';
    var aName = a.name ? a.name.toLowerCase() : '';
    var bSetNum = b.number || '';
    var bName = b.name ? b.name.toLowerCase() : '';
    if (aSetNum && !bSetNum) {
        return -1;
    }
    else if (bSetNum && !aSetNum) {
        return 1;
    }
    else {
        // Compare scene number does what we want...it's more generic than just scenes
        var numCompare = scenes_1.compareSceneNames(aSetNum, bSetNum, alpha);
        if (numCompare !== 0) {
            return numCompare;
        }
        else {
            return compareAlphanumArrays([aName], [bName]);
        }
    }
}
exports.setNumberNameCompare = setNumberNameCompare;
/** Breaks up a string into an array of strings by splitting on periods or numbers */
function breakup(t) {
    // tslint:disable-line
    if (typeof t === 'undefined' || t === null) {
        return [];
    }
    var tz = [];
    var x = 0;
    var y = -1;
    var n = 0;
    var i = 0;
    var j = 0;
    while ((i = (j = t.charAt(x++)).charCodeAt(0))) {
        var m = i === 46 || (i >= 48 && i <= 57) ? 1 : 0;
        if (m !== n) {
            tz[++y] = '';
            n = m;
        }
        if (y === -1) {
            ++y;
        }
        tz[y] = tz[y] ? tz[y] + j : j;
    }
    return tz;
}
exports.breakup = breakup;
/** Compares arrays of alpha numeric strings */
function compareAlphanumArrays(a, b) {
    // tslint:disable-line
    var check = nullCheck(a, b);
    if (check !== null) {
        return check;
    }
    for (var x = 0; a[x] && b[x]; x++) {
        var check2 = nullCheck(a[x], b[x]);
        if (check2 !== null) {
            return check2;
        }
        if (a[x] !== b[x]) {
            var c = Number(a[x]);
            var d = Number(b[x]);
            if (c == a[x] && d == b[x]) {
                return numberCompare(c, d);
            }
            else if (a[x].toLowerCase() !== b[x].toLowerCase()) {
                return a[x] > b[x] ? 1 : -1;
            }
        }
    }
    return a.length - b.length;
}
exports.compareAlphanumArrays = compareAlphanumArrays;
function isNumeric(value) {
    return /^-{0,1}\d+$/.test(value);
}
exports.isNumeric = isNumeric;
/**
 * Checks if either input is null or undefined
 * Returns null otherwise
 */
function nullCheck(a, b) {
    // tslint:disable-line
    if (a !== undefined && a !== null && (b === undefined || b === null)) {
        return -1;
    }
    else if ((a === undefined || a === null) &&
        b !== undefined &&
        b !== null) {
        return 1;
    }
    else if (a === undefined || a === null || b === undefined || b === null) {
        return 0;
    }
    return null;
}
exports.nullCheck = nullCheck;
function strcasecmp(fString1, fString2) {
    //   example 1: strcasecmp('Hello', 'hello')
    //   returns 1: 0
    var string1 = (fString1 + '').toLowerCase();
    var string2 = (fString2 + '').toLowerCase();
    if (string1 > string2) {
        return 1;
    }
    else if (string1 === string2) {
        return 0;
    }
    return -1;
}
exports.strcasecmp = strcasecmp;
/**
 *
 * function to compare values with numbers and letters
 * puts letters and then the number first
 * puts just the number second
 * puts the number and then letters third
 * EX:  A1,1,1A
 */
function compareLetterFirst(a, b) {
    if (!a && !b) {
        return 0;
    }
    if (!a) {
        return 1;
    }
    if (!b) {
        return -1;
    }
    var split_a = a.split(/[0-9]/);
    var split_b = b.split(/[0-9]/);
    if (split_a.length === 0 && split_b.length !== 0) {
        return 1;
    }
    else if (split_a.length !== 0 && split_b.length === 0) {
        return -1;
    }
    var num_a = a.replace(/[^0-9]/, '');
    var num_b = b.replace(/[^0-9]/, '');
    if (!isNaN(num_a) && !isNaN(num_b)) {
        if (num_a !== num_b) {
            return parseInt(num_a, 10) < parseInt(num_b, 10) ? -1 : 1;
        }
        else {
            var let_a = split_a[0].replace(/[0-9]/, '');
            var let_b = split_b[0].replace(/[0-9]/, '');
            var cmp = strcasecmp(let_a, let_b);
            if (cmp === 0) {
                let_a = a.replace(/[0-9]/, '');
                let_b = b.replace(/[0-9]/, '');
                return strcasecmp(let_a, let_b);
            }
            return cmp;
        }
    }
    else {
        if (!isNaN(num_a)) {
            return -1;
        }
        else if (!isNaN(num_b)) {
            return 1;
        }
        else {
            return strcasecmp(a, b);
        }
    }
}
exports.compareLetterFirst = compareLetterFirst;
